import React from "react";
import SheqForm from "../components/forms/SheqForm" 

const ProjectInformation: React.FC = () => {
  return (
   <>
   <SheqForm />
   </>
  );
};

export default ProjectInformation;
